import axios from 'axios';
import { LOG_URL } from '@/config';

function getDevice() {
  const userAgent = window.navigator.userAgent;

  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return 'ios.event';
  }

  if (userAgent.match(/android/i)) {
    return 'android.event';
  }

  return 'web.event';
}


function sendApiLog(res, store) {
  try {
    if (!res || !res.config || !res.config.url || res.config.url.indexOf('wlog') !== -1) {
      return;
    }

    const user = store.getters.currentUser || {};
    const now = new Date();
    const body = {
      method: res.config.method,
      api: res.config.url,
      code: res.status,
      uid: user.user_id,
      role: user.role,
      grade: user.grade,
      device: getDevice(),
      client_time: now.getTime(),
      origin: `${window.location.origin}${window.location.pathname}`,
      host: window.location.host,
      msg: (res.data || {}).error_description,
    };

    const parentIds = store.getters.getRouteQuery.parent_ids;

    if (parentIds) {
      const parentIdList = parentIds.split(',');

      parentIdList.forEach((parentId, i) => {
        body[`parent_id${i + 1}`] = parentId;
      });
    }

    axios.post(LOG_URL, body);
  } catch (err) {
    console.error('failed to send log with err:', err);
  }
}


export default (http, store) => {
  http.interceptors.response.use(
    (response) => {
      sendApiLog(response, store);

      return response;
    },

    (error) => {
      const { response } = error;

      sendApiLog(response, store);

      return Promise.reject(error);
    },
  );
};



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js